import './warningMessage.scss';
import WarningIcon from 'assets/icons/warning.svg';
import React, { useEffect } from "react"
import { translateText } from "../../../getTranslationsMyProfileUploadDocumentation";
import { recordLinkV2 } from "utilities/tagging"

export const WarningMessage = () => {
    useEffect(() => {
        recordLinkV2({
            categoriaEvento: "documentos/subida de documentacion/otros documentos",
            accionEvento: "mensaje/otros documentos",
            etiquetaEvento: "elegir categoria del listado"
        })
    },[])

  return (
      <div className="warning-message">
          <img src={WarningIcon} alt="warning" />
          <p>{translateText('othersCategoryWarning')}</p>
      </div>
  );
};
